import { Button } from "antd";

type ContactUsProps = {
  href: string;
};

export const ContactUs = ({ href }: ContactUsProps) => {
  return (
    <Button type="link" className="text" href={href}>
      contact us
    </Button>
  );
};
